export function InstagramIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>Instagram&apos;s logo</desc>
      <path
        d="M7.59665 0.5C3.59648 0.5 0.333496 3.76298 0.333496 7.76316V17.2368C0.333496 21.2365 3.59636 24.5 7.59665 24.5H17.0703C21.0701 24.5 24.3335 21.2366 24.3335 17.2368V7.76316C24.3335 3.76287 21.07 0.5 17.0703 0.5H7.59665ZM7.59665 2.39474H17.0703C20.0459 2.39474 22.4388 4.78703 22.4388 7.76316V17.2368C22.4388 20.2122 20.0457 22.6053 17.0703 22.6053H7.59665C4.62052 22.6053 2.22823 20.2124 2.22823 17.2368V7.76316C2.22823 4.78691 4.62041 2.39474 7.59665 2.39474ZM18.6493 4.92105C17.9514 4.92105 17.3861 5.48632 17.3861 6.18421C17.3861 6.88211 17.9514 7.44737 18.6493 7.44737C19.3472 7.44737 19.9124 6.88211 19.9124 6.18421C19.9124 5.48632 19.3472 4.92105 18.6493 4.92105ZM12.3335 6.18421C8.85677 6.18421 6.01771 9.02327 6.01771 12.5C6.01771 15.9767 8.85677 18.8158 12.3335 18.8158C15.8102 18.8158 18.6493 15.9767 18.6493 12.5C18.6493 9.02327 15.8102 6.18421 12.3335 6.18421ZM12.3335 8.07895C14.786 8.07895 16.7545 10.0475 16.7545 12.5C16.7545 14.9525 14.786 16.9211 12.3335 16.9211C9.88096 16.9211 7.91244 14.9525 7.91244 12.5C7.91244 10.0475 9.88096 8.07895 12.3335 8.07895Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default InstagramIcon
